var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_vm._v(" "+_vm._s(_vm.row.name)+" ")]),_c('td',[_vm._v(" "+_vm._s(_vm.row.total_used)+" ")]),_c('td',[_c('b-form-input',{attrs:{"id":"input-amount","type":"text"},on:{"change":_vm.onSumUpdated},model:{value:(_vm.amount),callback:function ($$v) {_vm.amount=$$v},expression:"amount"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }